import { DAYS, POSTS } from "@/pages/allAnalytics/constants";
import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils";

export const facebookFollowersGrowthConfig = [
    {
        plotName: "growth",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.followers",
        helpText: "analytics_growth.total_number_of_followers_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "growth",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]

export const facebookPlatformsGrowthConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "reach_and_impressions",
        metricName: "reach",
        sumMetrics: false,
        title: "analytics_growth.reach",
        helpText: "analytics_growth.total_number_of_reach_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.total_number_of_reactions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
    },
    {
        plotName: "posts_per_day_plot",
        metricName: "posts_per_day_plot",
        sumMetrics: false,
        title: "analytics_growth.posts",
        helpText: "analytics_growth.total_number_of_posts_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-images",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]


export const facebookDailyGrowthConfig = [
    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.change_in_total_daily_impressions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS, // This is used to divide the values by the number of days in the date range
    },
    {
        plotName: "reach_and_impressions",
        metricName: "reach",
        sumMetrics: false,
        title: "analytics_growth.reach",
        helpText: "analytics_growth.change_in_total_daily_reach_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.change_in_total_daily_reactions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    },
];


export const facebookContentGrowthConfig = [
    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.change_in_total_daily_post_impressions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
    {
        plotName: "reach_and_impressions",
        metricName: "reach",
        sumMetrics: false,
        title: "analytics_growth.reach",
        helpText: "analytics_growth.change_in_total_daily_post_reach_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.change_in_total_daily_post_reactions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
];
